import { withInstall } from '@antdv/utils';
import AComment from './src/Comment';

export const Comment = withInstall(AComment);

export default Comment;

export * from './src/props';
